export default __webpack_public_path__ + "bdaa58f953f1f3add111b59158209285.png";